export default "__VITE_ASSET__X6Wr9r8v__"